export default "__VITE_ASSET__2a691814__"